import { SettingsTitle, TabsNavigation } from '@/ui'
import { UsersDomainsForm } from '../components/UsersDomainsForm'
import { TEAM_DOMAINS_PATH, TEAM_PATH, useGenerateCompanyPath } from '@/libs'
import { Team } from '@/components/icons/Team'
import { useTranslation } from 'react-i18next'

export const MembersDomainsPage = () => {
  const { generatePath } = useGenerateCompanyPath()
  const { t } = useTranslation()

  const tabsList = [
    {
      link: generatePath(TEAM_PATH),
      title: t('sidebar.team'),
    },
    {
      link: generatePath(TEAM_DOMAINS_PATH),
      title: t('company-settings-page.domains'),
    },
  ]

  return (
    <>
      <TabsNavigation tabs={tabsList} />
      <SettingsTitle
        icon={<Team size={36} />}
        title={t('company-team-domains.title')}
        description={t('company-team-domains.description')}
      />
      <UsersDomainsForm />
    </>
  )
}
